"use client";

import { useEffect } from "react";
import { useAppConfiguration } from "appConfig";

export function Stepper({ steps, activeStep, refresh }: any) {
  const { isJinnyApp } = useAppConfiguration();
  const lineColorBefore = isJinnyApp
    ? "before:!bg-[#806375]"
    : "before:!bg-[#d89f4a]";
  const stepColor = isJinnyApp
    ? "after:!bg-[#806375] after:!text-white"
    : "after:!bg-[#d89f4a]";
  useEffect(() => {
    const activeStepItem = document.getElementById(`#${activeStep}`);
    activeStepItem?.scrollIntoView({
      behavior: "smooth",
      block: "center",
      inline: "center",
    });
  }, [activeStep, refresh]);

  return (
    <div className="overflow-x-auto pb-3 w-full md:w-fit md:mx-auto">
      <ul className="steps gap-3 w-max">
        {steps.map((step: string, index: number) => {
          const done = activeStep > index;
          const isActive = activeStep >= index;
          const recoloredLine = activeStep + 1 >= index;
          return (
            <li
              key={index}
              id={`#${index}`}
              data-content={done ? "✓" : null}
              className={`step ${recoloredLine ? lineColorBefore : ""} font-semibold ${
                isActive ? stepColor : "step-neutral after:!text-white"
              }`}
            >
              {step}
            </li>
          );
        })}
      </ul>
    </div>
  );
}
